export const TERMS_VERSION = '2026-09-21';
export const PRIVACY_VERSION = '2026-09-21';

export const formatLegalVersion = (version) => {
  const [year, month, day] = version.split('-').map(Number);
  return new Intl.DateTimeFormat('en-GB', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    timeZone: 'UTC',
  }).format(new Date(Date.UTC(year, month - 1, day)));
};
